import { render, staticRenderFns } from "./EmployeeDataTabs.vue?vue&type=template&id=083896fa&"
import script from "./EmployeeDataTabs.vue?vue&type=script&lang=js&"
export * from "./EmployeeDataTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports